import { root_props } from '../main';

export function has_feature_rookie_apply() {
    return ['li.tian@bidderdesk.com', 'jianlei.li@bidderdesk.com'].includes(root_props.user.email)
}

export function is_mi() {
    return ['mi.op@bidderdesk.com'].includes(root_props.user.email)
}